
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uGame/open_ubox",
      function () {
        return require("private-next-pages/uGame/open_ubox/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uGame/open_ubox"])
      });
    }
  